module.exports = __webpack_public_path__ + "static/media/platycleis_grisea_011_Tag_APA.e905fa1c.mp3";